/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {enums} from './enums';

const TransactionCommand = yup.object({
   commandText: yup.string(),
   workingDir: yup.string(),
   continueOnFailure: yup.boolean(),
   timeout: yup.number().integer(),
   type: yup.string(), //.oneOf(enums.commandType.keys),
});
export type ITransactionCommand = yup.InferType<typeof TransactionCommand>;

export const PreTransactionCommand = TransactionCommand.shape({
   type: yup.string().default(enums.commandType.enum.PRE),
});

export const PostTransactionCommand = TransactionCommand.shape({
   type: yup.string().default(enums.commandType.enum.POST),
});
